<template>
    <div class="card tyre border-0 mt-2">
        <div class="card-body border rounded">
            <div class="text-center row">
                <div class="col-12">
                    <img
                        :src="brandImagePath + tyre.brand_image"
                        class="img-fluid rounded bg-white w-50"
                        :alt="tyre.brand + ' ' + tyre.tyre_range + ' logo'"
                        height="135"
                        onError="this.src='https://colewood-automotive.s3-eu-west-1.amazonaws.com/Images/brand-coming-soon.png'"
                    />
                    <b class="d-block mt-2 mb-4">{{ tyre.tyre_range  }}</b>
                    <div class="tyre-image">
                        <a :href="tyreRangeUrl" :title="tyre.name">
                            <img :src="tyreImagePath + tyre.graphic" class="img-fluid" :alt="tyre.brand + ' ' + tyre.tyre_range + ' logo'" height="135" @error="replaceByDefault"/>
                        </a>
                    </div>
                </div>
                <div class="col-12 pe-0">
                    <div class="my-2">
                        <reviews
                            :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                            align="center"
                            mobile-align="center"
                        ></reviews>
                    </div>
                    <specialisms :tyre="updatedTyre"></specialisms>
                    <fitments v-if="tyre.fitments" :fitments="tyre.fitments" :fitment-summary="true" :fitment-count="tyre.range_fitment_count"></fitments>
                </div>
                <div class="col-12">
                    <b class="d-block mt-2 mb-3">Prices from &pound;{{ tyre.price }}</b>
                    <a class="btn btn-primary" :href="tyreRangeUrl">
                        View all sizes
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['tyre', 'tyreImagePath', 'brandImagePath', 'tyreRange', 'brandSlug'],
        components: {
        	
        },
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        },
        computed: {
            //This component is shared between tyre specialisms and tyre ranges, unfortunately the data isn't structured the same, resulting in the need for the below.
            tyreRangeUrl() {
                return this.baseUrl + '/' + this.tyre.brand_slug + '/' + this.tyre.slug;
            },
            //Tyre Range Tyre object is not structured the same as an ordinary tyre object, therefore add badges to root of object to include in shared components.
            updatedTyre() {
                var tyre = this.tyre;

                if(typeof(this.tyre.range_badges) != 'undefined' || typeof(this.tyre.badges) != 'undefined') {
                    var badges = typeof(this.tyre.range_badges) != 'undefined' ? this.tyre.range_badges : (typeof(this.tyre.badges) != 'undefined' ? this.tyre.badges : '');

                    _.forEach(badges, function(value, key) {
                        tyre[key] = value;
                    });

                    return tyre;
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .tyre {
        .card-header {
            background-color: transparent;
            max-height: 70px;
        }
        .card-body {
            position: relative;
            &.featured {
                border-bottom-left-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
            }
            .brand-image {
                img {
                    max-width: 170px;
                }
            }
            .tyre-image {
                position: relative;
                img {
                    height: 208px;
                }
            }
            .price {
                font-size: 22px;
            }
            .per {
                font-size: 12px;
            }
            .tyre-info-badge {
                position: absolute;
                bottom: 5px;
                left: -5px;
                text-align: left;
                div:nth-of-type(2) {
                    margin-top: 5px;
                }
            }
        }
    }
</style>